import React from 'react';
import { TbX } from 'react-icons/tb';

interface ButtonCloseProps {
  onClick: CallableFunction;
  disabled?: boolean;
  rounded?: boolean;
  fixedOnTop?: boolean;
  className?: string;
  outline?: boolean;
  type?: 'button' | 'submit' | 'reset' | undefined;
  iconSize?: number;
}

const ButtonClose = ({
  onClick = () => {},
  disabled = false,
  className,
  fixedOnTop = false,
  outline = false,
  type = 'button',
  iconSize = fixedOnTop ? 21 : 17

}: ButtonCloseProps) => {

  const handleClick = () => {
    onClick()
  }

  return (
    <button
      type={type}
      onClick={handleClick}
      disabled={disabled}
      className={`
        flex items-center justify-center
        h-7 w-7 rounded-full
        ${fixedOnTop ? 'absolute right-3 top-3 p-1' : ''}
        text-gray-400
        ring-1 outline-none
        transition-all ease-in-out duration-200
        cursor-pointer
        bg-white/10 active:bg-black/10 
        focus-visible:outline
        disabled:pointer-events-none disabled:opacity-50
        ${className}
        ${outline ? 'ring-gray-200 hover:ring-gray-300' : 'ring-transparent hover:bg-gray-100 '}
    `}>
      <div><TbX size={iconSize} aria-hidden="true" /></div>
    </button>
  )
}

export default ButtonClose;